import { Link, createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { RoleActivationCard } from '@/components/auth/role-activation-card';

export const Route = createFileRoute('/_app/settings/')({
  component: SettingsPage,
});

function SettingsPage(): React.ReactElement {
  return (
    <div className="grid gap-4 md:grid-cols-2">
      <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
        <h2 className="font-display mb-1 text-base">Profil</h2>
        <p className="text-muted-foreground mb-4 text-xs">
          Identité, langues CECRL, compétences, portfolio.
        </p>
        <div className="flex flex-col gap-2">
          <Link to="/profile/bidder/individual" className="text-primary text-sm hover:underline">
            Profil Bidder Individuel →
          </Link>
          <Link to="/profile/bidder/company" className="text-primary text-sm hover:underline">
            Profil Bidder Société →
          </Link>
        </div>
      </section>

      <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
        <h2 className="font-display mb-1 text-base">Identité du donneur d&apos;ordre</h2>
        <p className="text-muted-foreground mb-4 text-xs">
          Raison sociale et identifiant légal repris sur les devis officiels.
        </p>
        <Link to="/settings/identity" className="text-primary text-sm hover:underline">
          Renseigner mon identité →
        </Link>
      </section>

      <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
        <h2 className="font-display mb-1 text-base">Sécurité</h2>
        <p className="text-muted-foreground mb-4 text-xs">Mot de passe, 2FA TOTP.</p>
        <Link to="/settings/security" className="text-primary text-sm hover:underline">
          Gérer la sécurité →
        </Link>
      </section>

      <RoleActivationCard />

      <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
        <h2 className="font-display mb-1 text-base">Facturation</h2>
        <p className="text-muted-foreground mb-4 text-xs">Plan, devise (figée), facturation.</p>
        <Link to="/settings/plan" className="text-primary text-sm hover:underline">
          Gérer le plan &amp; la facturation →
        </Link>
      </section>

      <section className="border-border bg-card rounded-2xl border p-6 shadow-[0_8px_24px_-12px_hsl(30_10%_30%/0.06)]">
        <h2 className="font-display mb-1 text-base">Confidentialité</h2>
        <p className="text-muted-foreground mb-4 text-xs">
          Traitement IA, opt-out RGPD, données personnelles.
        </p>
        <Link to="/settings/privacy" className="text-primary text-sm hover:underline">
          Gérer la confidentialité →
        </Link>
      </section>
    </div>
  );
}
